import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ApiService } from '../../utils/api';
import ProtectedRoute from './ProtectedRoute';
import { useEventRoute } from '../../utils/eventRef';

// The event desk needs a viewer login unless the event opens it to everyone (kiosk mode).
const DeskAccessGate = ({ children }) => {
  const { eventId } = useEventRoute();

  const { data: event, isLoading } = useQuery({
    queryKey: ['publicEvent', eventId],
    queryFn: () => ApiService.getPublicEvent(eventId),
    enabled: !!eventId,
    retry: false,
  });

  if (eventId && isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white" />
      </div>
    );
  }

  if (event?.deskPublic === true) return children;
  return <ProtectedRoute requiredRole="VIEWER">{children}</ProtectedRoute>;
};

export default DeskAccessGate;
